var styleDataHash = "dd0259d8";
const injectCss = () => {
  var css = `.F1oa9{height:18px;position:relative;width:18px}.ZUsDL,._7ADDa{height:100%;position:absolute;top:0;width:100%;fill:none;stroke-linecap:round}[dir=ltr] .ZUsDL,[dir=ltr] ._7ADDa{left:0}[dir=rtl] .ZUsDL,[dir=rtl] ._7ADDa{right:0}._7ADDa{stroke:currentColor;opacity:.3}[dir=ltr] ._7ADDa{animation:_6alGs 666ms linear infinite}[dir=rtl] ._7ADDa{animation:FtfXK 666ms linear infinite}.ZUsDL{stroke:currentColor}[dir=ltr] .ZUsDL{animation:_6alGs 2s linear infinite}[dir=rtl] .ZUsDL{animation:FtfXK 2s linear infinite}@keyframes _6alGs{to{transform:rotate(1turn)}}@keyframes FtfXK{to{transform:rotate(-1turn)}}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var double_loader_default = {
  "wrapper": "F1oa9",
  "top": "_7ADDa",
  "bottom": "ZUsDL",
  "rotation-ltr": "_6alGs",
  "rotation-rtl": "FtfXK"
};
export {
  double_loader_default as default,
  injectCss
};
//# sourceMappingURL=double-loader-scss.js.map
